// @owner ClientPlatform

import React, {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {Sso} from './sso';

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <Sso />
  </StrictMode>
);
